/**
 * Trust badge for item pages — verified booth vendor at a named flea market.
 */
export default function AuthenticVendorBadge({ marketName, vendorName, vendorBooth }) {
  return (
    <div
      className="rounded-xl border-2 border-emerald-500/40 bg-emerald-50 dark:bg-emerald-950/40 p-4 flex gap-3 items-start"
      role="status"
      aria-label="Authentic verified vendor"
    >
      <div
        className="shrink-0 w-12 h-12 rounded-full bg-emerald-600 text-white flex items-center justify-center text-2xl shadow-md"
        aria-hidden
      >
        ★
      </div>
      <div className="min-w-0 flex flex-col gap-1">
        <p className="font-semibold text-emerald-900 dark:text-emerald-100 text-lg leading-tight">
          Authentic verified vendor
        </p>
        <p className="text-sm text-emerald-800 dark:text-emerald-200/90">
          {vendorName}
          {vendorBooth ? ` · Booth ${vendorBooth}` : ''}
          {marketName ? ` at ${marketName}` : ''}
        </p>
        <p className="text-xs text-emerald-700 dark:text-emerald-300/80">
          Listed through FleaMarketHub — checkout in-app, pick up at the market.
        </p>
      </div>
    </div>
  );
}
